export const UPDATE_COUNTS = '/app/store/payCardManagement/UPDATE_TAB_COUNTS'
export const CREATED_NEW_CARD = '/app/store/payCardManagement/CREATED_NEW_CARD'
